// apps/web/src/components/landing-v2/FinalCTA.tsx
import { Link } from 'react-router-dom'

/** Closing call to action. Italic display headline, two CTAs.
 *  Secondary CTA acknowledges the visitor may need help, not a pitch. */
export function FinalCTA() {
  return (
    <section className="mx-auto max-w-[1100px] px-5 py-24 text-center md:px-8">
      <h2 className="reveal font-display text-5xl italic font-light md:text-6xl">
        What's the question?
      </h2>
      <div className="reveal mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/sign-up"
          className="rounded-md bg-gold px-6 py-3 text-sm font-medium text-cosmic-black shadow-glow-gold hover:bg-gold-light transition-colors"
        >
          Begin a reading
        </Link>
        <Link
          to="/help"
          className="rounded-md border border-hairline-strong px-6 py-3 text-sm text-text-secondary hover:text-text-primary hover:border-white/[0.16] transition-colors"
        >
          I need a little guidance
        </Link>
      </div>
    </section>
  )
}
